var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewSegmentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.38417 1.25508C8.72429 0.914972 9.27572 0.914972 9.61583 1.25508L16.7449 8.38417C17.085 8.72429 17.085 9.27572 16.7449 9.61583L9.61583 16.7449C9.27572 17.085 8.72429 17.085 8.38417 16.7449L1.25508 9.61583C0.914972 9.27572 0.914972 8.72429 1.25508 8.38417L8.38417 1.25508Z",
    stroke: "#6940F2",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewSegmentIcon);
export default __webpack_public_path__ + "static/media/NewSegmentIcon.c8ba78dd3a8223a2523ea4b83363a3a2.svg";
export { ForwardRef as ReactComponent };